import { createSelector } from 'reselect';

const selectGlobalDBNBizMappings = (state: any) => state.globalDBNBizMappings;


export const selectGlobalDBNBizMappingsCurrentItem = createSelector([selectGlobalDBNBizMappings], (globalDBNBizMappings) => globalDBNBizMappings.current);

export const selectGlobalDBNBizMappingsListItems = createSelector([selectGlobalDBNBizMappings], (globalDBNBizMappings) => globalDBNBizMappings.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectGlobalDBNBizMappingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalDBNBizMappingsQueryItems = createSelector([selectGlobalDBNBizMappings], (globalDBNBizMappings) => globalDBNBizMappings.query);

export const selectGlobalDBNBizMappingsCreatedItem = createSelector([selectGlobalDBNBizMappings], (globalDBNBizMappings) => globalDBNBizMappings.create);

export const selectGlobalDBNBizMappingsUpdatedItem = createSelector([selectGlobalDBNBizMappings], (globalDBNBizMappings) => globalDBNBizMappings.update);

export const selectGlobalDBNBizMappingsReadItem = createSelector([selectGlobalDBNBizMappings], (globalDBNBizMappings) => globalDBNBizMappings.read);

export const selectGlobalDBNBizMappingsDeletedItem = createSelector([selectGlobalDBNBizMappings], (globalDBNBizMappings) => globalDBNBizMappings.delete);

export const selectGlobalDBNBizMappingsSearchedItems = createSelector([selectGlobalDBNBizMappings], (globalDBNBizMappings) => globalDBNBizMappings.search);

export const selectGlobalDBNBizMappingsItemsCount = createSelector([selectGlobalDBNBizMappings], (globalDBNBizMappings) => globalDBNBizMappings.count);

export const selectGlobalDBNBizMappingsItemsFilter = createSelector([selectGlobalDBNBizMappings], (globalDBNBizMappings) => globalDBNBizMappings.filter);